import RequestManager from "src/requests/RequestManager";
import { Team } from "../interfaces";
import { allTeams, isMockDataActive } from "../mockData";
import { TeamsTask } from "../tasks";
import { parseTeam } from "../utils";

// Se usa en NodoMundial/Equipos
export default async function getAllTeams(): Promise<Team[]> {
    if(isMockDataActive) {
        return allTeams
    }
    const task = new TeamsTask();
    const result = await RequestManager.addRequest(task);
    const teams = result.teams.map(parseTeam) || [];
    return teams
    // .sort((a: Team, b: Team) => a.name > b.name ? 1 : -1);
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getAllTeams.ts